import React, {Component} from 'react';
import {Assets} from "../../assets";

class Banner extends Component {

    state = {navbarHeight: 0}

    componentDidMount() {
        if (this.props.fullImage) {
            this.updateNavbarHeight()
            window.addEventListener('resize', this.updateNavbarHeight)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateNavbarHeight)
    }

    // navbar is position: fixed, so offset the image to keep it from being covered
    updateNavbarHeight = () => {
        const bottoms = [...document.querySelectorAll('.navbar-area')].map(el => el.getBoundingClientRect().bottom)
        this.setState({navbarHeight: Math.max(0, ...bottoms)})
    }

    render() {
        const background = this.props.background ?? Assets.subBanner

        if (this.props.fullImage) {
            return (
                <div style={{marginTop: this.state.navbarHeight}}>
                    <img src={background} alt={this.props.headertitle}
                         style={{display: 'block', width: '100%', height: 'auto'}}/>
                </div>
            )
        }

        const inlineStyle = {
            backgroundImage: `url(${background})`
        }
        return (
            <div className="breadcrumb-area jarallax" style={inlineStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner">
                                <h1 className="page-title">{this.props.headertitle}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default Banner
